import { AhaEditorUtils, HtmlSerializer, slate } from '@aha-app/aha-editor-v2';

/**
 * Sanitize text for insertion into the Aha! Editor.
 */
export function sanitizeTextForEditor(text: string): string {
  const editor = slate.createEditor();
  editor.children = new HtmlSerializer(undefined, {
    preserveWhitespace: true,
    enableFontFamilyMark: true,
  }).deserialize(text).children;
  AhaEditorUtils.Selection.selectAll(editor);
  return new HtmlSerializer(editor).serialize();
}
